import { camelCaseKeys, toErrorData } from '@utils';
import { isWhitelisted } from '@api/config/whitelistedUrlConfig';
import { HTTP_METHOD } from '@api/endpoints/constant';


const responseCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

const createCacheKey = (config) => {
  const sortedParams = config.params
    ? Object.fromEntries(Object.entries(config.params).sort())
    : {};
  return `${config.method}-${config.url}-${JSON.stringify(sortedParams)}`;
};

export const responseInterceptor = (response) => {
  const { config, status, data, headers } = response;

  if (isWhitelisted(config.url)) {
    try {
      response.data = JSON.parse(data);
    } catch {
      response.data = data;
    }
    return response;
  }

  const cacheKey = createCacheKey(config);

  if (config.method === HTTP_METHOD.GET && responseCache.has(cacheKey)) {
    const cached = responseCache.get(cacheKey);
    if (Date.now() - cached.timestamp < CACHE_DURATION) {
      return structuredClone(cached.response);
    }
    responseCache.delete(cacheKey);
  }

  const contentType = headers['content-type'] || '';
  if (data && contentType.includes('application/json')) {
    try {
      const parsed = JSON.parse(data);
      response.data = camelCaseKeys(parsed, { deep: true }); // ✅ Deep camelCase
    } catch {
      response.data = data; // fallback if JSON.parse fails
    }

    if (config.method === HTTP_METHOD.GET && status === 200) {
      responseCache.set(cacheKey, {
        response: structuredClone(response),
        timestamp: Date.now()
      });
    }
  } else {
    response.data = data;
  }

  return response;
};

export const errorInterceptor = (error) => {
  return Promise.reject(toErrorData(error));
};
